<template>
    <div class="kgr-grid kgr-grid--1of2 kgr-grid--gutters kgr-grid--bigGutters">
        <div class="kgr-grid__cell">
            <kgr-form-row
                :label="$t('member.academicTitle')"
                :error="error"
                field-name="academicTitle"
            >
                <kgr-titles-select
                    v-model="member.academicTitle"
                    :club-id="clubId"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.firstName')"
                :error="error"
                field-name="firstName"
                required
            >
                <input
                    v-model.trim="member.firstName"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.lastName')"
                :error="error"
                field-name="lastName"
                required
            >
                <input
                    v-model.trim="member.lastName"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.dateOfBirth')"
                :error="error"
                field-name="dateOfBirth"
                :tooltip="$t('Format: TT.MM.JJJJ')"
            >
                <kgr-date-picker
                    v-model.trim="member.dateOfBirth"
                    @enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.birthName')"
                :error="error"
                field-name="birthName"
            >
                <input
                    v-model.trim="member.birthName"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.gender')"
                :error="error"
                field-name="gender"
            >
                <kgr-gender-select
                    v-model="member.gender"
                    as-input
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.placeOfBirth')"
                :error="error"
                field-name="placeOfBirth"
            >
                <input
                    v-model.trim="member.placeOfBirth"
                    type="text"
                    class="kgr-input"
                    @keyup.enter="onKeyUpEnter"
                />
            </kgr-form-row>

            <kgr-form-row
                :label="$t('member.nationality')"
                :error="error"
                field-name="nationality"
            >
                <kgr-countries-select v-model="member.nationality" />
            </kgr-form-row>
        </div>

        <div class="kgr-grid__cell">
            <kgr-avatar-form-row :member="member" />

            <kgr-form-row
                :label="$t('member.comment', {'member': member.firstName} )"
                :error="error"
                field-name="comment"
            >
                <textarea
                    v-model.trim="member.comment"
                    class="kgr-input"
                    rows="5"
                ></textarea>
            </kgr-form-row>

            <kgr-form-row
                v-if="member.isBookkeepingCommentViewable"
                :label="$t('member.bookkeepingComment', {'member': member.firstName})"
                :error="error"
                field-name="bookkeepingComment"
            >
                <textarea
                    v-model.trim="member.bookkeepingComment"
                    class="kgr-input"
                    rows="5"
                ></textarea>
            </kgr-form-row>
        </div>
    </div>
</template>

<script>
import AcademicTitleSelect from './AcademicTitleSelect';
import AvatarFormRow from './AvatarFormRow';
import CountriesSelect from '../common/form/select/CountriesSelect';
import DatePicker from '../common/form/picker/DatePicker';
import Error from '../../js/model/Error';
import FormRow from '../common/form/FormRow';
import GenderSelect from '../common/form/select/GenderSelect';
import Member from '../../js/dto/Member';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-avatar-form-row': AvatarFormRow,
        'kgr-gender-select': GenderSelect,
        'kgr-date-picker': DatePicker,
        'kgr-countries-select': CountriesSelect,
        'kgr-titles-select': AcademicTitleSelect,
    },
    props: {
        member: {
            type: Member,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
    },
    methods: {
        onKeyUpEnter() {
            this.$emit('enter');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
